export default __webpack_public_path__ + "static/media/discordanceLogo.99935969.svg";